<h2>Contacts</h2>
<p-table #dt [value]="contacts" [columns]="cols" styleClass="p-datatable-striped">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-columns="columns" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.contactType}}</td>
            <td class="td--hover-show">{{data.customerContactValue}}</td>
            <td><input type="checkbox" [checked]="data.isCorrespondenceEnabled" disabled="true"></td>
            <td><input type="checkbox" [checked]="data.isPrimary" disabled="true"></td>
            <td><input type="checkbox" [checked]="data.isPreferredContactMethod" disabled="true"></td>
            <td><input type="checkbox" [checked]="data.isInvalid" disabled="true"></td>
            <td>{{data.updatedDate | dateTime}}</td>
            <td class="td--hover-show">{{data.updatedBy}}</td>
        </tr>
    </ng-template>
</p-table>
